<div class="main-outer">
  <app-header></app-header>
    <div class="dashboard-content">
        <div class="container">
            <div class="title-block">
                <h1>
                    <a class="back-btns" href="javascript:void(0);" routerLink="">
                      <svg width="18" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 8.2L7.98523 1V5C19.913 5 21.2891 12.7424 20.9578 17C20.4569 14.852 20.2243 11.4 7.98523 11.4V15.4L1 8.2Z" stroke="#414141" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        </a> 
                        Background Service Status</h1>
            </div>
            <div class="dashboard-cards">
              <div class="card">
                <h3><img src="assets/img/ocr-icon.png" alt="OCR Icon"> OCR Processing</h3>
                <p *ngIf="OCRServiceStatus == 'Fetching'">Fetching...</p>
                <p *ngIf="OCRServiceStatus == 'Running'"><img src="assets/img/correct-icon.png" alt="Running">{{OCRServiceStatus}}</p>
                <p *ngIf="OCRServiceStatus == 'Error' || OCRServiceStatus == 'Stopped'"><img src="assets/img/delete-icon.png" alt="Stopped">{{OCRServiceStatus}}</p>
              </div>

              <div class="card">
                <h3><img src="assets/img/recycle-bin-icon.png" alt="Recycle Bin Icon"> Recycle Bin Cleanup</h3>
                <p *ngIf="RecycleBinServiceStatus == 'Fetching'">Fetching...</p>
                <p *ngIf="RecycleBinServiceStatus == 'Running'"><img src="assets/img/correct-icon.png" alt="Running">{{RecycleBinServiceStatus}}</p>
                <p *ngIf="RecycleBinServiceStatus == 'Error' || RecycleBinServiceStatus == 'Stopped'"><img src="assets/img/delete-icon.png" alt="Stopped">{{RecycleBinServiceStatus}}</p>
              </div>
            </div>
        </div>
    </div>
</div>
